__turbopack_context__.v({
  "active": "nav-pill-module__rZBqNW__active",
  "badge": "nav-pill-module__rZBqNW__badge",
  "horizontal": "nav-pill-module__rZBqNW__horizontal",
  "icon": "nav-pill-module__rZBqNW__icon",
  "label": "nav-pill-module__rZBqNW__label",
  "navPill": "nav-pill-module__rZBqNW__navPill",
  "sliding": "nav-pill-module__rZBqNW__sliding",
  "tab": "nav-pill-module__rZBqNW__tab",
  "vertical": "nav-pill-module__rZBqNW__vertical",
});
